import { render, staticRenderFns } from "./ListTypeDocument.vue?vue&type=template&id=5d1a2cf4&scoped=true"
import script from "./ListTypeDocument.vue?vue&type=script&lang=js"
export * from "./ListTypeDocument.vue?vue&type=script&lang=js"
import style0 from "./ListTypeDocument.vue?vue&type=style&index=0&id=5d1a2cf4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1a2cf4",
  null
  
)

export default component.exports